import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';
import { useOperations } from './useOperations';
import { operationsRpc } from '@/lib/operations';
import type { JerseyIdentifierContext } from '@klothiq/domain';

export function useJerseyIdentifiers(profileId?: string, productId?: string) {
  const { organization, profile, access } = useAuth();
  const operations = useOperations();
  return useQuery({
    queryKey: [
      'jersey_identifiers',
      organization?.id,
      profile?.id,
      access?.access_version,
      profileId,
      productId,
    ],
    enabled: !!organization && !!profileId && operations.data?.modules.jersey_identifiers === 1,
    queryFn: () =>
      operationsRpc<JerseyIdentifierContext>('get_jersey_identifier_context_v1', {
        p_profile_id: profileId,
        p_product_id: productId || null,
      }),
    retry: false,
  });
}
